import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from "../../components/ui/card";
import { Progress } from "../../components/ui/progress";
import { Button } from '../../components/ui/button';
import { ArrowRight } from 'lucide-react';

interface TodaysHabitSnapshotProps {
  // Accept actual data as props
  completedCount?: number | null;
  totalCount?: number | null;
  isLoading?: boolean;
}

const TodaysHabitSnapshot: React.FC<TodaysHabitSnapshotProps> = ({ 
  completedCount,
  totalCount,
  isLoading = false 
}) => {

  // Use provided counts, default to 0 if null/undefined
  const displayCompleted = completedCount ?? 0;
  const displayTotal = totalCount ?? 0;
  
  // Handle case where total is 0 to avoid division by zero
  const progress = displayTotal > 0 ? (displayCompleted / displayTotal) * 100 : 0;
  const showData = typeof completedCount === 'number' && typeof totalCount === 'number';

  return (
    <Card>
      <CardHeader>
        <CardTitle>Today's Habits</CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div className="space-y-2">
            <div className="h-2 w-full rounded-full bg-muted animate-pulse"></div>
            <div className="h-4 w-24 rounded bg-muted animate-pulse"></div>
          </div>
        ) : showData ? (
          <>
            <Progress value={progress} className="h-2 mb-2" aria-label={`${displayCompleted} of ${displayTotal} habits completed`} />
            <p className="text-sm text-muted-foreground">
              {displayCompleted} / {displayTotal} Completed
            </p>
          </>
        ) : (
            <p className="text-sm text-muted-foreground italic">No daily habits tracked yet.</p> // Display message if no data
        )}
      </CardContent>
      <CardFooter>
        <Button variant="link" asChild className="p-0 h-auto text-sm text-muted-foreground hover:text-foreground">
          <Link to="/habits">
            View All Habits <ArrowRight className="ml-1 h-4 w-4" />
          </Link>
        </Button>
      </CardFooter>
    </Card>
  );
};

export default TodaysHabitSnapshot; 